export const LANDLORD_STATUS = {
  ACTIVE: '1',
  INACTIVE: '2',
};

export const LANDLORD_STATUS_LABELS = {
  [LANDLORD_STATUS.ACTIVE]: 'Active',
  [LANDLORD_STATUS.INACTIVE]: 'Inactive',
};

/** Normalize API / legacy values to a status code ('1' | '2'). */
export const normalizeLandlordStatus = (raw) => {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (Object.values(LANDLORD_STATUS).includes(s)) return s;

  const lower = s.toLowerCase();
  const byName = {
    active: LANDLORD_STATUS.ACTIVE,
    inactive: LANDLORD_STATUS.INACTIVE,
  };
  return byName[lower] ?? null;
};

export const getLandlordStatusLabel = (raw) => {
  const code = normalizeLandlordStatus(raw);
  if (code) return LANDLORD_STATUS_LABELS[code];
  if (raw == null || raw === '') return '—';
  const s = String(raw).trim();
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

export const getLandlordStatusBadgeVariant = (raw) => {
  const code = normalizeLandlordStatus(raw);
  if (code === LANDLORD_STATUS.ACTIVE) return 'success';
  if (code === LANDLORD_STATUS.INACTIVE) return 'danger';
  return 'muted';
};
